import { inject } from 'vue';

export function useAgreements(config) {
    const trans = inject('trans');
    const resource_url = inject('resource_url');

    const opinionCounter = window.store_config_data?.opinion_counters?.[0] ?? null;

    const providerLogos = {
        opineo: 'opineo-horizontal.svg',
        arukereso: 'arukereso-new.svg',
        compari: 'compari-new.svg',
        'heureka-cz': 'heureka-new.svg',
        'heureka-sk': 'heureka-new.svg',
        jevtinije: 'jevtinije-new.svg',
        pazaruvaj: 'pazaruvaj-new.svg',
        trustpilot: 'trustpilot-logo.webp',
    };
    const providerLogo = opinionCounter ? (providerLogos[opinionCounter.source] ?? 'opineo-horizontal.svg') : null;
    const providerTitle = opinionCounter?.source ? opinionCounter.source.charAt(0).toUpperCase() + opinionCounter.source.slice(1) : '';

    const opinionImgSrc = providerLogo ? `<img src="/img/logos/${providerLogo}" alt="${providerTitle}" title="${providerTitle}" loading="lazy" height="14" />` : '';

    const opinionBlock = opinionCounter
        ? (providerLogo ? opinionImgSrc : `<strong>${providerTitle}</strong>`)
        : '';

    const agreements = {
        tos: {
            text: trans('agreements.tos.text'),
            // label: trans('pages.checkout.partials.checkout-agreements.p1', {
            //     link: `<a class="text-underline" href="${resource_url('regulamin')}">${trans('agreement.regulations')}</a>`,
            // }),
            value: false,
            source: config?.source || '',
        },
        marketing: {
            text: trans('agreements.marketing.text'),
            // label: trans('entrypoints.content.contact-with-expert-new.p7'),
            value: false,
            source: config?.source || '',
        },
        external_opinion: {
            text: trans('agreements.external_opinion.text'),
            // label: trans('pages.checkout.partials.checkout-agreements.p4', {
            //     portal_icon: opinionBlock,
            // }),
            value: false,
            source: config?.source || '',
        },
        sms: {
            text: trans('agreements.sms.text'),
            // label: trans('global.agreement.order-sms'),
            value: false,
            source: config?.source || '',
        },
        contact: {
            text: trans('agreements.contact.text'),
            // label: trans('global.agreement.order-contact'),
            value: false,
            source: config?.source || '',
        },
        scplus: {
            text: trans('agreements.scplus.text'),
            value: false,
            source: config?.source || '',
        },
        voucher: {
            text: trans('agreement.voucher.text'),
            value: false,
            source: config?.source || '',
        },
        vipclubtos: {
            text: "Akceptuję regulamin programu lojalnościowego",
            value: false,
            source: config?.source || ''
        }
    };

    const agreementLabels = {
        tos: trans('pages.checkout.partials.checkout-agreements.p1', {
            link: `<a class="text-underline" href="${window.resource_url('regulamin')}">${trans('agreement.regulations')}</a>`,
        }),
        marketing: trans('entrypoints.content.contact-with-expert-new.p7'),
        external_opinion: trans('pages.checkout.partials.checkout-agreements.p4', {
            portal_icon: opinionBlock,
        }),
        sms: trans('global.agreement.order-sms'),
        contact: trans('global.agreement.order-contact'),
        scplus: trans('agreements.scplus.label', {
            link: `<a class="text-underline" href="${window.resource_url('regulamin-savicki-care-plus')}" target="_blank">${trans('agreements.scplus.tos')}</a>`,
        }),
        scplus_wr: trans('agreements.scplus_wr.label', {
            link: `<a class="text-underline" href="${window.resource_url('regulamin-savicki-care-plus-obraczki-slubne')}" target="_blank">${trans('agreements.scplus.tos')}</a>`,
        }),
        voucher: trans('agreement.voucher.label', {
            link: `<a class="text-underline" href="${window.resource_url('regulamin-karty-podarunkowej')}" target="_blank">${trans('global.texxt184')}</a>`,
        }),
        vipclubtos: `Akceptuję <a class="text-underline" href="/regulamin-programu-lojalnosciowego-2026-pl.pdf" target="_blank">regulamin programu lojalnościowego</a>`
    }

    const agreementExtend = {
        marketing: trans('agreement.contact.text2', {
            link: `<a class="text-underline" href="${window.resource_url('polityka-prywatnosci')}">${trans('agreement.here')}</a>`,
            personal_data_administrator: window.store_config_data?.agreements?.personal_data_administrator,
        })
    }

    return { agreements, agreementLabels, agreementExtend };
}
